import { createTypedSelector } from "../common/root-reducer-selector";
import { RootState } from "../types";

export const appStateSelector = createTypedSelector(
  (state) => state,
  (state: RootState) => state["app-state"]
);